import { useState, useEffect, useLayoutEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import QueryString from 'query-string'
import { Platform } from 'react-native'
import userActions from './../redux/user/userActions'
import { userSelector } from './../redux/user/userSelector'
import { loginSelector } from '../redux/login/loginSelector'
import { stage } from '../../env.json'

export const useDemo = (onLogin) => {
  const timeRef = useRef()
  const [demoLoading, setDemoLoading] = useState(false)
  const [queryParams] = useState(Platform.OS === 'web' ? QueryString.parse(location.search) : null)
  const [attemps, setAttemps] = useState(0)
  const [isDemo] = useState(stage === 'demo')
  const [demoError, setDemoError] = useState(false)
  const dispatch = useDispatch()
  const { userAdded, error: userError } = useSelector(userSelector)
  const { error } = useSelector(loginSelector)
  useLayoutEffect(() => {
    if (isDemo && queryParams && queryParams.email) {
      if ((error)) {
        setDemoError(true)
        setDemoLoading(false)
        if (Platform.OS === 'web') {
          timeRef.current = setTimeout(() => {
            window.location.replace('/login')
          }, 5000)
        }
      }
    }
    return () => {
      clearTimeout(timeRef.current)
    }
  }, [error, isDemo, queryParams])

  useEffect(() => {
    if (isDemo) {
      if (queryParams && queryParams.email && !userAdded && !userError) {
        if (Object.keys(queryParams).length === 1) {
          dispatch(userActions.addUser({
            email: queryParams.email,
            password: 'Edge2019#1',
            carrier_id: 'demo'
          }))
          setDemoLoading(true)
        }
      }
    }
  }, [queryParams, dispatch, userAdded, userError, isDemo])

  useEffect(() => {
    if (isDemo) {
      if (userAdded && userAdded.auth0_id && !attemps) {
        setAttemps(attemps + 1)
        onLogin({ email: queryParams.email, password: 'Edge2019#1' })
      }
    }
  }, [userAdded, onLogin, queryParams, attemps, isDemo])

  return {
    isDemo,
    demoError,
    demoLoading,
    userAdded
  }
}
